import { getQuery } from 'redux-saga-requests'

import { FETCH_INFO } from './constants'
import { StateType } from './types'

export const priceInfoSelector = getQuery<StateType>({
  type: FETCH_INFO,
  defaultData: [],
})
